import { Fragment, useEffect, useRef, useState } from "react";
import "./active-admin-message.css";
import { useManagerMessageStore } from "../../stores/managerMessageStore";

export default function ActiveAdminMessage() {
  const MESSAGE_DISPLAY_DURATION = 5000;

  const messages = useManagerMessageStore((s) => s.messages);

  const [isVisible, setIsVisible] = useState(false);
  const timeoutRef = useRef(null);

  // 🔹 show on updates (WebSocket → Zustand → UI)
  useEffect(() => {
    if (messages.length === 0) return;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    setIsVisible(true);

    timeoutRef.current = setTimeout(() => {
      setIsVisible(false);
    }, MESSAGE_DISPLAY_DURATION);
  }, [messages]);

  if (!isVisible || messages.length === 0) {
    return null;
  }

  return (
    <Fragment>
      <div className="active-admin-message user-select-none">
        {messages.map((msg) => (
          <p key={msg.id}>{msg.message}</p>
        ))}
      </div>
    </Fragment>
  );
}